/** @file Applies one confirmed commit's patches to the DocSlice and retires the own batches it carries. */
import { applyPatches, enablePatches, type Patch } from 'immer';
import type { PendingBatch } from '../../stores/liveStore';
import type { DocSlice } from '../../stores/types';

enablePatches();

/** The slice at `rev` (patches in order, a root replace `path: []` included) and the batches still pending. */
export function applyConfirmed(slice: DocSlice, batches: readonly PendingBatch[], rev: number, patches: readonly Patch[]): { slice: DocSlice; batches: PendingBatch[] } {
  const kept = batches.filter((b) => b.committedRev === null || b.committedRev > rev);
  return { slice: { confirmed: applyPatches(slice.confirmed, patches), rev, pending: kept.flatMap((b) => b.pending) }, batches: kept };
}
